// Main entry point - exports commonly used utilities
export * from './types';

// Re-export key client utilities
export { LeadClient, validateLeadData, sanitizeLeadData } from './client';

// Re-export key server utilities
export { createLeadHandler, verifyRecaptcha, createBusinessFlowHandler, createSimpleBusinessFlowHandler } from './server';

// Version info
export const version = '2.3.0';